import { Box } from '@hub/box';
import { Button } from '@hub/button';
import React from 'react';
import usePlaceholder from '@scentregroup/shared/components/search/use-placeholder';
import { SearchMediumIcon } from '@hub/icon';
import { jsx as _jsx } from "react/jsx-runtime";
export const SearchButton = _ref => {
  let {
    onClick,
    controlledElementId,
    sx,
    country,
    centre
  } = _ref;
  const placeholder = usePlaceholder({
    country,
    centre
  });
  return /*#__PURE__*/_jsx(Box, {
    role: "search",
    sx: sx,
    "data-id": "search-button_index_SearchButton_Box",
    children: /*#__PURE__*/_jsx(Button, {
      variant: "searchBar",
      colorScheme: "smoke",
      size: "icon-lg",
      width: "size-full",
      maxWidth: [null, null, 'size-4xl'],
      leftIcon: /*#__PURE__*/_jsx(SearchMediumIcon, {
        boxSize: "size-icon-sm",
        "data-id": "search-button_index_SearchButton_SearchMediumIcon"
      }),
      "aria-label": "Open Search, you can search stores, brands, products, and more",
      "aria-controls": controlledElementId,
      onClick: onClick,
      "data-id": "search-button_index_SearchButton_Box_Button",
      children: placeholder
    })
  });
};